import { http } from "./http";

export const getAppSettings = async () => {
  const res = await http.get("/api/admin/app-settings");
  return res.data;
};

export const updateAppSettings = async (settings: {
  local_delivery_enabled?: boolean;
  default_delivery_fee_cents?: number;
  use_zones_for_delivery?: boolean;
  delivery_eta_start?: string;
  delivery_eta_end?: string;
  free_delivery_minimum?: number;
  wholesale_free_delivery_minimum?: number;
  backorder_policy?: "none" | "wholesale_only" | "both";
  wholesale_min_order_value?: number;
}) => {
  const res = await http.put("/api/admin/app-settings", settings);
  return res.data;
};